// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content085_wrapper__3EKqK","blocks":"Content085_blocks__Ajxmd","image":"Content085_image__m4age"};